import React from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';
import OrivonLogo from './OrivonLogo';

export default function WhySection() {
  const m = useMediaQuery('(max-width: 767px)');

  const rows = [
    {
      other: 'Generic advice — not specific to you.',
      nova: 'Clinically informed answers — specific to your chapter.',
    },
    {
      other: 'You figure out what actually applies to you.',
      nova: 'Nova knows your chapter — no repeating yourself.',
    },
    {
      other: 'Starts from scratch every time you return.',
      nova: 'Remembers your full journey — every time.',
    },
    {
      other: 'One-size communities — not matched to your stage.',
      nova: 'Matched to women at your exact stage and moment.',
    },
    {
      other: 'No follow-through after you close the tab.',
      nova: 'Checks in, follows up, and stays with you.',
    },
    {
      other: 'Guidance and community live in separate places.',
      nova: 'Community + intelligence, always connected.',
    },
  ];

  const pad = m ? '48px 18px' : '64px 48px';

  return (
    <section
      style={{
        padding: pad,
        backgroundColor: 'rgb(255, 252, 249)',
        scrollMarginTop: 88,
      }}
    >
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <p
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.1em',
            color: 'var(--muted)',
            textTransform: 'uppercase',
            textAlign: 'center',
            marginBottom: 12,
          }}
        >
          Why OrivonAI
        </p>

        <h2
          className="serif"
          style={{
            fontSize: 'clamp(26px, 3vw, 32px)',
            fontWeight: 700,
            textAlign: 'center',
            color: 'var(--text)',
            lineHeight: 1.25,
            marginBottom: 12,
          }}
        >
          Other tools look things up.
          <br />
          <em style={{ color: 'var(--pink)', fontStyle: 'italic' }}>
            We show up before you have to.
          </em>
        </h2>

        <p
          style={{
            fontSize: 15,
            color: 'var(--muted)',
            textAlign: 'center',
            maxWidth: 640,
            margin: '0 auto 40px',
            lineHeight: 1.65,
          }}
        >
          Most tools wait for a question. The platform watches your data — your protocol, your cycle, your last appointment —
          and surfaces what matters before you&apos;ve thought to ask.
        </p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: m ? '1fr' : '1fr 1fr',
            gap: 14,
          }}
        >
          <div
            style={{
              borderRadius: 'var(--r)',
              padding: m ? '20px 18px' : '24px 28px',
              background: 'var(--card)',
              border: '1px solid var(--border)',
            }}
          >
            <span
              style={{
                fontSize: 10,
                fontWeight: 700,
                padding: '3px 10px',
                borderRadius: 20,
                display: 'inline-block',
                marginBottom: 18,
                background: 'var(--sand-2)',
                color: 'var(--text-2)',
              }}
            >
              Other platforms
            </span>

            {rows.map((row, i) => (
              <div
                key={row.other}
                style={{
                  fontSize: 14,
                  padding: '12px 0',
                  borderBottom: i < rows.length - 1 ? '0.5px solid var(--border)' : 'none',
                  lineHeight: 1.45,
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 10,
                  minHeight: 46,
                }}
              >
                <span
                  style={{
                    flexShrink: 0,
                    fontSize: 13,
                    marginTop: 1,
                    color: 'var(--sand-3)',
                  }}
                  aria-hidden
                >
                  ✕
                </span>
                <span style={{ color: 'var(--muted)' }}>{row.other}</span>
              </div>
            ))}
          </div>

          <div
            style={{
              borderRadius: 'var(--r)',
              padding: m ? '20px 18px' : '24px 28px',
              background: 'var(--pink-l)',
              borderLeft: '3px solid var(--pink)',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 18,
              }}
            >
              <OrivonLogo height={m ? 24 : 30} />
            </div>

            {rows.map((row, i) => (
              <div
                key={row.nova}
                style={{
                  fontSize: 14,
                  padding: '12px 0',
                  borderBottom: i < rows.length - 1 ? '0.5px solid rgba(212, 83, 126, 0.15)' : 'none',
                  lineHeight: 1.45,
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 10,
                  minHeight: 46,
                }}
              >
                <span
                  style={{
                    flexShrink: 0,
                    fontSize: 13,
                    marginTop: 1,
                    color: 'var(--pink)',
                  }}
                  aria-hidden
                >
                  ✓
                </span>
                <span style={{ color: 'var(--pink-dk)', fontWeight: 500 }}>{row.nova}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
